import { render, staticRenderFns } from "./Sucursal.vue?vue&type=template&id=27bd86fa"
import script from "./Sucursal.vue?vue&type=script&lang=js"
export * from "./Sucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports